export const spacing = {
  base: "2",
  md: "4"
};
